import React from 'react';
import Menu from '../Components/Menu';

function England() {
  return (
    <div>
      <div>
        {/* Navbar & Hero Start */}
        <div className="container-fluid position-relative p-0">
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
            <div className="container py-5">
              <div className="row justify-content-center py-5">
                <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                  <h1 className="display-3 text-white animated slideInDown">
                    England
                  </h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item">
                        <a href="#">Home</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="#">Destination</a>
                      </li>
                      <li
                        className="breadcrumb-item text-white active"
                        aria-current="page"
                      >
                        England
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Navbar & Hero End */}

        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Destination
          </h6>
          <h1 className="mb-5">A Review of Tourist Destinations in England</h1>
        </div>
      </div>

      {/* Content */}

      <div className="container">
        <div className="content">
          <p>
            England is a captivating country that offers a remarkable blend of
            history, culture, and natural beauty. From iconic landmarks to
            picturesque countryside, there are numerous tourist destinations to
            explore. In this review, we will highlight some of the top
            attractions in England.
          </p>
          <h3 className="text">1. Capital London</h3>
          <p>
            Located in the southeast of England, right on the tranquil banks of
            the River Thames, the extravagant and splendid capital city of
            London resembles a grand fortress or a castle from fairy tales.
            London is often likened to a miniature world, as it boasts numerous
            architectural wonders, historical sites, museums, art galleries,
            lush parks, shopping districts, entertainment areas, and even an
            underground city.
          </p>
          <center>
            <img src="img/england1.jpg" alt="" />
          </center>
          <br />
          <br />
          <p>
            The city of London has been the capital of the United Kingdom since
            the 5th century, after the Romans withdrew from England. Through
            relentless efforts, London has developed a modern infrastructure
            system with numerous major trading centers. It is also a global
            financial and economic hub, with the British Pound being the
            highest-valued currency in the world.
          </p>
          <p>
            When visiting England, make sure to stop by London to explore its
            famous and beautiful landmarks. Some must-see attractions in the
            city include the iconic Big Ben clock tower, the Tower Bridge
            spanning the River Thames, Westminster Palace, Buckingham Palace,
            and the two prominent museums, Victoria and Albert Museum.
          </p>
          <h3 className="text">2. Cambridge City</h3>
          <p>
            Cambridge is known as the second-largest city and the administrative
            center of Cambridgeshire. This charming city is situated on the
            River Cam, north of London. It is renowned as a cultural and
            entertainment hub in the eastern part of England, with a rich and
            distinctive cultural heritage that attracts tourists year after
            year.
          </p>
          <center>
            <img src="img/england2.jpg" alt="" />
          </center>{' '}
          <br />
          <br />
          <p>
            When visiting the city of Cambridge, tourists will be captivated by
            the charming ancient buildings with their delightful arches,
            interspersed with clean and beautiful narrow alleys. What sets this
            place apart is the warm and friendly nature of the locals, which
            will surely win your heart. The most distinctive feature of
            Cambridge is its picturesque setting along the River Cam, allowing
            you to take boat rides and explore the idyllic colleges and historic
            universities that line the riverbanks.
          </p>
          <h3 className="text">3. Thành phố York</h3>
          <p>
            York is the most ancient city in England and one of the notable
            cities in the country's history, particularly known for the "War of
            the Roses" - a power struggle between the Houses of Lancaster and
            York. It stands as a symbol of power, serving as the stronghold of
            the House of York with its emblem, the White Rose. Its legacy still
            remains today, represented by the city's enclosing city walls and
            the iconic rose symbol marking the main entrance to the city.
          </p>
          <center>
            <img src="img/england3.jpg" alt="" />
          </center>
          <br />
          <br />
          <h3 className="text">4. Manchester City</h3>
          <p>
            Located in the northern part of the United Kingdom, Manchester is a
            vibrant and bustling city known for its sophisticated restaurants
            and trendy bars. It is the second-largest city in England, following
            the capital city of London, and boasts a strong economy with a
            skyline dominated by high-rise buildings, commercial centers,
            entertainment districts, and a range of museums. When exploring
            Manchester, you can visit the cozy pubs along the streets, enjoy
            leisurely moments with friends, and soak in the romantic scenery of
            the city
          </p>
          <center>
            <img src="img/england4.jpg" alt="" />
          </center>{' '}
          <br />
          <br />
          <p>
            Moreover, Manchester is renowned for its passion for the beautiful
            game, with dramatic and thrilling football matches brought to life
            by some of the world's top teams. In particular, it is home to two
            powerhouse football clubs, Manchester United and Manchester City. A
            dream destination in England would be incomplete without the mention
            of Manchester – a glamorous city that any football enthusiast would
            love to visit. Manchester has also "usurped" London's throne to
            claim the top spot in ESPN's ranking of the liveliest sports cities
            in England.
          </p>
          <h3 className="text">5. Liverpool City</h3>
          <p>
            Liverpool is a city and metropolitan borough located on the eastern
            bank of the River Mersey in the Northwest region of England. It is a
            historic port city and a vibrant cultural and tourist hub, featuring
            commercial buildings, administrative structures, historic
            neighborhoods, cultural monuments, and the largest port in the UK.
            Liverpool attracts tourists from all over the world and is
            considered an affordable travel destination. Whether you have a
            passion for sports, music, or history, Liverpool has something to
            offer that will satisfy your interests.
          </p>
          <center>
            <img src="img/england5.jpg" alt="" />
          </center>{' '}
          <br />
          <br />
          <p>
            Regarded as the most beautiful port city in the United Kingdom, the
            historic center of Liverpool was recognized by UNESCO as a World
            Heritage site in 2004 and was awarded the title of European Capital
            of Culture in 2008. Being a gateway city, Liverpool has a diverse
            population, culture, and religion, with significant influences from
            Ireland and Wales. It is also home to the oldest Black community in
            England, adding to the city's rich cultural tapestry.
          </p>
          <p>
            In addition to the dreamy cities mentioned above, the United Kingdom
            has many more destinations awaiting your exploration and
            experiences. Get ready and prepare for these fantastic sightseeing
            trips right away.
          </p>
        </div>
      </div>
      {/* End Content */}
    </div>
  );
}

export default England;
